(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('AlertingSettingOverviewController', AlertingSettingOverviewController);

    AlertingSettingOverviewController.$inject = ['$uibModalInstance', '$state', 'AlertingSettings', 'pagingParams'];

    function AlertingSettingOverviewController ($uibModalInstance, $state, AlertingSettings, pagingParams) {
        var vm = this;
        vm.alertsToDelete = [];
        if(pagingParams.alertsToDelete[0].alertSystemType.name === 'slack') {
            pagingParams.alertsToDelete.forEach(function (value) {
                vm.alertsToDelete.push(value.slackIntegration.channel);
            });
        } else {
            pagingParams.alertsToDelete.forEach(function (value) {
                vm.alertsToDelete.push(value.actionIdentifier);
            });
        }

        vm.clear = function() {
            $uibModalInstance.close();
        };

        vm.confirm = function () {
            if(pagingParams.alertType) {
                AlertingSettings.alertingSettings({alertType: pagingParams.alertType}, pagingParams.alertingSettings);
            } else {
                AlertingSettings.delete({id:pagingParams.domainToDelete});
            }
            vm.clear();
        };

    }
})();
